<template>
	<div id="minecraft-app" class="col-8">
		<h2>Minecraft Controller</h2>

		<div
			v-for="commandType in commandTable"
			:key="commandType.type"
			class="row"
		>
			<h3 class="col-3">{{ commandType.type }}</h3>
			<div class="col-9 input-group">
				<button
					class="btn btn-primary form-control"
					v-for="commands in commandType.commands"
					:key="commands.command"
					v-on:click="send_command(commands.command)"
				>
					{{ commands.name }}
				</button>
			</div>
		</div>

		<br />

		<textarea
			class="col-12 form-control"
			rows="10"
			v-model="results"
			style="resize: none;"
			placeholder="Results"
			readonly
		></textarea>

		<br />

		<a
			href="https://minecraft.zipixx.com/#/647/64/1154/-6/Eldaria/Eldaria%20Overworld"
			target="_blank"
			><button class="btn btn-secondary form-control">Eldaria Map</button></a
		>

		<!--p>
				Server:
				<button class="ctrl-input" v-on:click="get_log()">Logs</button>
			</p>

			<p>
				Player:
				<button class="ctrl-input" v-on:click="send_command('list')">
					List
				</button>
			</p>

			<hr style="height:0; border:0; border-top: 2px solid #111;" />
			<img src='https://mcapi.us/server/image?ip=minecraft.zipixx.com&theme=dark&title=Eldaria'-->
		<!--p>
				Eldaria Map:
				<a
					href="https://minecraft.zipixx.com/map/#/647/64/1154/-6/Eldaria/Eldaria%20Overworld"
					target="_blank"
					style="color:#ccc"
					>click here</a
				>
			</p>

			<p>
				Wiki:
				<input
					class="ctrl-input"
					v-model="wikiSearch"
					v-on:keyup.enter="wiki_search()"
					style="width:125px;"
					type="text"
					placeholder=" query"
				/>
				<button class="ctrl-input" v-on:click="wiki_search()">Search</button>
			</p>
		</div>
		</div-->
	</div>
</template>

<script>
import * as minecraft_api from '@/api/minecraft';

export default {
	name: 'Minecraft.vue',
	data: function() {
		return {
			token: '',
			results: '',
			wikiSearch: '',
			commandTable: [
				{
					type: 'Weather',
					commands: [
						{
							name: 'Sun',
							command: 'weather clear'
						},
						{
							name: 'Rain',
							command: 'weather rain'
						},
						{
							name: 'Thunder',
							command: 'weather thunder'
						}
					]
				},
				{
					type: 'Time',
					commands: [
						{
							name: 'Day',
							command: 'time set 0'
						},
						{
							name: 'Night',
							command: 'time set night'
						}
					]
				}
			]
		};
	},
	methods: {
		send_command: function(command) {
			if (!this.token_check(command)) {
				return;
			}
			minecraft_api
				.send_command(command, this.token)
				.then(res => {
					this.write_results(res, true);
				})
				.catch(error => {
					this.write_results(
						'Failed: ' +
							command +
							' (' +
							error.response.status +
							' ' +
							error.response.data +
							')',
						true
					);
					//alert(error.response.status + ' ' + error.response.data);
				});
		},
		get_log: function() {
			if (!this.token_check('<logs>')) {
				return;
			}
			minecraft_api.get_logs(this.token).then(res => {
				//this.write_results('Success: <logs> ' + res, false);
				this.results = res;
			});
			/*
					res => {
						this.write_results(
							'Failed: <logs> (' + res.status + ' ' + res.data + ')',
							true
						);
						alert(res.status + ' ' + res.data);
					}
				);
				*/
		},
		set_cookie: function() {
			document.cookie = 'api_token=' + this.token;
		},
		write_results: function(msg, clip) {
			let tmp =
				new Date().toTimeString().split(' ')[0] +
				' ' +
				msg +
				'\n' +
				this.results;
			if (clip && tmp.split('\n').length > 20) {
				this.results = tmp
					.split('\n')
					.slice(0, 20)
					.join('\n');
			} else {
				this.results = tmp;
			}
		},
		token_check: function(command) {
			if (this.token === '') {
				this.write_results('Failed: ' + command + ' (api_token missing)');
				return false;
			}
			return true;
		},
		wiki_search: function() {
			if (this.wikiSearch === '') {
				return;
			}
			window.open(
				'https://minecraft.gamepedia.com/index.php?title=Special:Search&search=' +
					this.wikiSearch
			);
		}
	},
	mounted: function() {
		let cookie = document.cookie.match(
			new RegExp('(^| )' + 'api_token' + '=([^;]+)')
		);
		if (cookie) {
			this.token = cookie[2];
		}
	}
};
</script>

<style scoped>
#minecraft-app {
	margin: 0 auto;
	margin-top: 25px;
	max-width: 650px;
}
</style>
